import React, {useEffect, useRef, useState} from 'react';
import {X, ArrowLeft, Copy, FileText, Laptop} from 'lucide-react';
import DateTimeSelector from './DueTimeSelector';

function CloneModal({
                        isOpen,
                        onClose,
                        onConfirm,
                        assignmentName,
                        setAssignmentName,
                        dueDate,
                        dueTime,
                        timezone,
                        setDueDate,
                        setDueTime,
                        errorMessage,
                        setErrorMessage,
                        originalCloneName,
                        submissionType,
                        setSubmissionType,
                        isEssay,
                        isFlexible,
                        cloneClassId,
                        setCloneClassId,
                        userClasses,
                        // isGroupSubmission,
                        // setIsGroupSubmission
                    }) {
    const modalRef = useRef();
    const [step, setStep] = useState('details'); // Start directly with details for cloning
    const [hoveredOption, setHoveredOption] = useState(null);

    useEffect(() => {
        const handleClickOutside = event => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const ClassSelector = () => (
        <div className="flex items-center input-entry-box font-normal bg-white mt-3">
            <select
                value={cloneClassId}
                className="ml-2.5 actual-input text-black placeholder-black w-full"
                onChange={e => setCloneClassId(e.target.value)}
            >
                <option value="" disabled>
                    Select Class
                </option>
                {userClasses.map(classItem => (
                    <option key={classItem.id} value={classItem.id}>
                        {classItem.name}
                    </option>
                ))}
            </select>
        </div>
    );

    const renderDetailsForm = () => (
        <div className="space-y-4">
            <div className="flex flex-col gap-4">
                <div className="bg-orange-50 p-3 rounded-lg mb-2 flex items-center">
                    <Copy className="w-5 h-5 text-orange-500 mr-2" />
                    <span className="text-sm text-orange-700">Cloning: {originalCloneName}</span>
                </div>
                
                <div className="relative">
                    <input
                        type="text"
                        value={assignmentName}
                        className={`w-full p-3 rounded-lg border ${errorMessage !== '' ? 'border-red-500' : 'border-gray-200'} focus:border-orange-300 focus:ring-2 focus:ring-orange-100 outline-none transition-all`}
                        placeholder="New Assignment Name"
                        onChange={e => {
                            setAssignmentName(e.target.value);
                            setErrorMessage(e.target.value.length > 70 ?
                                'Assignment name must not exceed 70 characters.' : '');
                        }}
                    />
                </div>

                <ClassSelector />

                {submissionType === 'student' && (
                    <DateTimeSelector
                        dueDate={dueDate}
                        setDueDate={setDueDate}
                        dueTime={dueTime}
                        setDueTime={setDueTime}
                        timezone={timezone}
                        errorMessage={errorMessage}
                        onFocus={() => setErrorMessage('')}
                    />
                )}
                {errorMessage && (
                    <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
                )}

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        className={`
                            w-full px-5 py-2.5 rounded-xl text-[0.875rem] font-medium transition-all duration-200 hover:transform hover:-translate-y-0.5 shadow-sm hover:shadow
                            ${!assignmentName || !cloneClassId || (submissionType === 'student' && (!dueDate || !dueTime)) ?
                            'bg-gray-100 text-gray-400 cursor-not-allowed' :
                            'bg-gradient-to-br from-[#e4b17a] to-[#c99b69] text-white hover:from-[#c99b69] hover:to-[#b38a5e]'
                        }
                        `}
                        disabled={!assignmentName || !cloneClassId || (submissionType === 'student' && (!dueDate || !dueTime))}
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm();
                        }}
                    >
                        Clone Assignment
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        isOpen && (
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm overflow-y-auto h-full w-full z-50 flex justify-center items-center">
                <div
                    ref={modalRef}
                    className="relative mx-auto p-6 bg-white w-full max-w-[500px] rounded-xl shadow-xl"
                    style={{
                        boxShadow: '0 0 0 1px rgba(0,0,0,0.05), 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)'
                    }}
                >
                    <button
                        className="absolute right-4 top-4 p-1 rounded-full hover:bg-gray-100 transition-colors"
                        onClick={onClose}
                    >
                        <X className="w-5 h-5 text-gray-400"/>
                    </button>
                    
                    <div className="space-y-6">
                        {renderDetailsForm()}
                    </div>
                </div>
            </div>
        )
    );
}

export default CloneModal;
